/**
 * AMCログイン画面
 *
 */

import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FunctionIdType, PageIdType } from '../../../interfaces';
import { AswServiceStoreService, CommonLibService, PageInitService, PageLoadingService } from '../../../services';
import { AmcLoginService } from './amc-login.service';
import { CheckboxComponent } from '../../../components/base-ui-components/form/checkbox/checkbox.component';
import { SupportModalIdComponent } from '../../../components/support-class/support-modal-id-component';
import { AswbeAuthorizationRequest } from 'src/sdk-authorization';
import { AswValidators } from '../../../helpers';
import { AmcLoginPayload } from './amc-login.state';
import { Router } from '@angular/router';
import { SignalService } from './signal.service';

@Component({
  selector: 'asw-amc-login',
  templateUrl: './amc-login.component.html',
  providers: [AmcLoginService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmcLoginComponent extends SupportModalIdComponent {
  constructor(
    private _common: CommonLibService,
    private _service: AmcLoginService,
    private _router: Router,
    private _aswServiceStoreService: AswServiceStoreService,
    private _pageInitService: PageInitService,
    private _signalService: SignalService,
    private _pageLoadingService: PageLoadingService
  ) {
    super(_common, _pageInitService);
    this.subscribeService('GetSignalLoginService', this._signalService.loginSignal$, () => {
      this.clickLogin(null, true);
    });
  }

  init() {
    //フォームコントロール作成
    this.idNameFormContrl = new FormControl('', [
      AswValidators.required({ params: { key: 0, value: 'label.amcAccountNumber' } }),
      AswValidators.numeric({ params: { key: 0, value: 'label.amcAccountNumber' } }),
      AswValidators.lengths({
        fixed: 10,
        params: [
          { key: 0, value: 'label.amcAccountNumber' },
          { key: 1, value: 10 },
        ],
      }),
    ]);
    this.passwordFormContrl = new FormControl(
      '',
      AswValidators.required({ params: { key: 0, value: 'label.password' } })
    );
    //仮ログイン判定
    if (!this.isNotLogin()) {
      this.idName = this._common.amcMemberStoreService.amcMemberData.amcNumber;
      this.labelIdName = this.idName.substring(this.idName.length - 4, this.idName.length).padStart(10, '*');
    }

    this.isSkipEnable = !!this.payload?.skipEvent;

    this.closeWithUrlChange(this._router);
  }
  destroy() {}
  reload() {}

  @ViewChild('checkboxComponent') checkboxComponent?: CheckboxComponent;

  /**
   * 処理方法が変わるかもしれないのでラッピングしておく
   * @returns
   */
  isNotLogin() {
    return this._common.isNotLogin();
  }

  subPageId: string = PageIdType.LOGIN;
  subFunctionId: string = FunctionIdType.LOGIN;
  public idName = '';
  public labelIdName = '';
  public password = '';
  public idNameFormContrl!: FormControl;
  public passwordFormContrl!: FormControl;
  public isSkipEnable = false;

  public override payload: AmcLoginPayload | null = {};

  /**
   * ログインボタン　クリック
   * @param $event
   * @param verifyLogin ログイン前処理のスキップ有無(true : スキップする false : スキップしない)
   * @returns
   */
  async clickLogin($event: any, verifyLogin: boolean = false) {
    //データ取得
    if (this.isNotLogin()) {
      this.idName = this.idNameFormContrl.value;
      this.idNameFormContrl.updateValueAndValidity();
      if (this.idNameFormContrl.errors != null) {
        this.idNameFormContrl.markAsUntouched;
        return;
      }
    }
    this.passwordFormContrl.updateValueAndValidity;
    if (this.passwordFormContrl.errors != null) {
      return;
    }
    this.password = this.passwordFormContrl.value;
    //入力チェック
    if (this._service.checkIdPass(this.idName, this.password)) {
      return;
    }
    if (this.payload?.beforeLoginEvent && !verifyLogin) {
      this.payload.beforeLoginEvent();
    } else {
      //リクエストパラメータ作成
      const request: AswbeAuthorizationRequest = {
        amcNumber: this.isNotLogin() ? this.idName : undefined,
        password: this.password,
        persistent: this.checkboxComponent?.checked ?? false,
        orderId: this._aswServiceStoreService.aswServiceData.orderId || undefined,
        lastName: this._aswServiceStoreService.aswServiceData.lastName,
        firstName: this._aswServiceStoreService.aswServiceData.firstName,
        matchesToTraveler: this.payload?.matchesToTraveler ? this.payload.matchesToTraveler : false,
        matchesToMileageRedemptionMember: this.payload?.matchesToMileageRedemptionMember
          ? this.payload.matchesToMileageRedemptionMember
          : false,
      };
      //ログインAPI呼び出し
      this._pageLoadingService.startLoading();
      const ret = await this._service.login(request);
      this._pageLoadingService.endLoading();

      //レスポンス処理
      if (ret.status === 200) {
        //正常終了
        if (this.payload?.submitEvent) {
          this.payload.submitEvent();
        }
        this._signalService.sendMergeConfirmSignal();
        this.close();
      } else if ((ret.status === 400 || ret.status === 401) && this._common.apiError) {
        //APIエラー(400、401)
        this._signalService.isMergeConfirm = false;
        this._signalService.sendMergeConfirmSignal();
        this._service.apiError(this._common.apiError);
      } else {
        this._signalService.isMergeConfirm = false;
        this._signalService.sendMergeConfirmSignal();
      }
    }
  }

  /**
   * ログインなしで進むボタン　クリック
   * @param $event
   */
  clickContinue($event: any) {
    if (this.payload?.skipEvent) {
      this.payload.skipEvent();
    }
    this.close();
  }
}
